import { call, put, takeLatest } from "redux-saga/effects";
import { showAlert } from "../../alertSlice";
import { publishWorkflowApi } from "../../../api/apiLists/workflow";
import {
  publishWorkflowFailure,
  publishWorkflowRequest,
  publishWorkflowStart,
  publishWorkflowSuccess
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";

function* handlePublishWorkflow(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    yield put(publishWorkflowStart());

    const req = action.payload || { operation: "PUBLISH_WORKFLOW", payload: {} };
    const res = yield callWorkflowApi(publishWorkflowApi, req);

    if (res?.status) {
      yield put(publishWorkflowSuccess(res?.data || null));
      yield put(showAlert({
        message: res?.data?.message || "Your workflow is now live and actively monitoring for triggers.",
        type: "success"
      }));
      return;
    }

    const errMsg = res?.errMsg || "Failed to publish workflow";
    yield put(publishWorkflowFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  } catch (error) {
    const errMsg = error.message || "Failed to publish workflow";
    yield put(publishWorkflowFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  }
}

export default function* workflowPublishSaga() {
  yield takeLatest(publishWorkflowRequest.type, handlePublishWorkflow);
}
